import { cva } from 'class-variance-authority';
import { FontWeights } from '../enums/font-weights';
import { Sizes } from '../enums/sizes';
import { TextSizes } from '../enums/typography-text-sizes';
import { ButtonVariants } from '../enums/variants';
import { textVariants } from './typography-text-variants';

const labelSm = textVariants({
  size: TextSizes.SM,
  weight: FontWeights.SEMIBOLD,
});
const labelMd = textVariants({
  size: TextSizes.MD,
  weight: FontWeights.SEMIBOLD,
});

export const buttonVariants = cva(
  `inline-flex shrink-0 scale-100 items-center justify-center gap-1.5 whitespace-nowrap rounded-lg transition-all active:not-disabled:scale-[0.99] disabled:opacity-50 disabled:cursor-not-allowed [&_svg]:shrink-0 outline-none focus-visible:ring-2 focus-visible:ring-focus-ring focus-visible:ring-offset-2 aria-invalid:border-error`,
  {
    variants: {
      variant: {
        [ButtonVariants.PRIMARY]:
          'border border-on-solid bg-brand-solid text-primary_on-brand shadow-xs hover:not-disabled:bg-brand-solid_hover [&_svg]:opacity-60',
        [ButtonVariants.PRIMARY_NEUTRAL]:
          'border border-on-solid bg-secondary-solid text-primary_on-brand shadow-xs hover:not-disabled:bg-secondary-solid_hover [&_svg]:opacity-60',
        [ButtonVariants.SECONDARY]:
          "border border-primary bg-primary text-secondary shadow-xs hover:not-disabled:bg-primary_hover hover:not-disabled:text-secondary_hover [&_svg:not([class*='text-'])]:text-fg-quaternary",
        [ButtonVariants.TERTIARY]:
          "text-tertiary hover:not-disabled:bg-primary_hover hover:not-disabled:text-secondary_hover [&_svg:not([class*='text-'])]:text-fg-quaternary",
        [ButtonVariants.LINK_PRIMARY]:
          "text-brand-secondary hover:not-disabled:text-brand-secondary_hover [&_svg:not([class*='text-'])]:text-fg-brand-secondary",
        [ButtonVariants.LINK_SECONDARY]:
          "text-tertiary hover:not-disabled:text-secondary_hover [&_svg:not([class*='text-'])]:text-fg-quaternary",
        [ButtonVariants.DESTRUCTIVE]:
          'border border-on-solid bg-error-solid text-white shadow-xs hover:not-disabled:bg-error-solid_hover',
        [ButtonVariants.FILTER]:
          'border rounded-md border-primary bg-primary hover:not-disabled:border-utility-gray-400 hover:not-disabled:bg-utility-gray-50 data-[active=true]:border-utility-gray-600 data-[active=true]:bg-utility-blue-50 hover:not-disabled:data-[active=true]:bg-utility-blue-100',
        [ButtonVariants.ICON]:
          "text-tertiary hover:not-disabled:bg-primary_hover hover:not-disabled:text-secondary_hover [&_svg:not([class*='text-'])]:text-fg-quaternary",
      },
      size: {
        [Sizes.XS]: `h-7 px-2 ${labelSm} [&_svg]:size-4`,
        [Sizes.SM]: `h-8 px-2.5 ${labelSm} [&_svg]:size-4`,
        [Sizes.MD]: `h-9 px-3 ${labelSm} [&_svg]:size-5`,
        [Sizes.LG]: `h-10 px-3.5 ${labelSm} [&_svg]:size-5`,
        [Sizes.XL]: `h-11 gap-2 px-4 ${labelMd} [&_svg]:size-5`,
        [Sizes.FILTER]: `h-[30px] px-2.5 ${labelSm} [&_svg]:size-4`,
        [Sizes.ICON]: 'size-8 [&_svg]:size-4',
      },
    },
    compoundVariants: [
      {
        variant: [ButtonVariants.LINK_PRIMARY, ButtonVariants.LINK_SECONDARY],
        class: 'h-auto gap-1 p-0 shadow-none',
      },
      { variant: ButtonVariants.ICON, class: 'aspect-square p-0 shadow-none' },
    ],
    defaultVariants: {
      variant: ButtonVariants.PRIMARY,
      size: Sizes.SM,
    },
  }
);
